import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';

export const templateVcenter = document.createElement('template');

templateVcenter.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id="details-section">
    <div class="details-header-section">
      <gz-text fontSize='14' id='integration-description' class="custom-space field-description"></gz-text>
      <div class="card-logo-container">
        <img id="integration-image" src="app/webcomponents/assets/images/integrations/vmware-logo.png"/>
      </div>
    </div>

    <gz-title fontSize="11" class="subsection-title" fontWeight="600" id="details-section-title"></gz-title>

    <gz-form-field id='integration-company-form-field' class="details-input-form-field" label='' required>
      <gz-single-select-complex gz-form-input labelWidth='240'></gz-single-select-complex>
      <gz-input-error></gz-input-error>
    </gz-form-field>
    <gz-form-field id="integration-name" class="vcenter-input-form-field" label="" required>
      <gz-input gz-form-input class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error></gz-input-error>
    </gz-form-field>
    <gz-form-field id="hostname" class="vcenter-input-form-field" label="" required>
      <gz-input gz-form-input class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error></gz-input-error>
    </gz-form-field>
     <gz-form-field id="port" class="details-input-form-field" label="" required>
      <gz-input gz-form-input class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error></gz-input-error>
    </gz-form-field>
     <gz-form-field id="username" class="details-input-form-field" label="" required>
      <gz-input gz-form-input class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error></gz-input-error>
    </gz-form-field>
    <gz-form-field id="password" class="details-input-form-field" label="" required>
      <gz-input gz-form-input type="password" class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error></gz-input-error>
    </gz-form-field>


    <gz-form-field id='customize-sync'>
      <gz-checkbox gz-form-input id='customize-sync-checkbox' label='' checked="true"></gz-checkbox>
      <gz-text fontSize='13' id='customize-sync-description' class="custom-space field-description"></gz-text>
    </gz-form-field>

    <div class="time-container">
      <div class="retry-interval-container">
        <gz-text fontSize='13' id='retry-interval-label'></gz-text>
        <gz-input-number id='retry-interval' class="details-input-form-field" label='' required>
          <gz-input gz-form-input class="input-content" placeholder="" inputwidth="300"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-input-number>
      </div>

      <div class="max-tries-container">
        <gz-text fontSize='13' id='max-tries-label'></gz-text>
        <gz-input-number id='max-tries' class="details-input-form-field" label='' required>
          <gz-input gz-form-input class="input-content" placeholder="" inputwidth="300"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-input-number>
      </div>
    </div>

    <gz-toggle gz-form-input id='use-ssl'></gz-toggle>
    <gz-text fontSize='13' id='use-ssl-description' class="custom-space field-description"></gz-text>

    <gz-form-field id='view-type' class='label-mw-250' label='' required>
      <gz-radio-group id='view-type-group' gz-form-input>
        <gz-text fontSize='14' class='pl-3 mb-2 custom-text-line-height' id='view-type-description'></gz-text>
        <gz-radio class='mb-1' id='view-type-vms-and-templates'></gz-radio>
        <gz-radio id='view-type-hosts-and-clusters'></gz-radio>
      </gz-radio-group>
    </gz-form-field>

  </div>
`;
